import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CurrencyAccountService } from '@services/currency-account.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ew-select-currency',
  templateUrl: './select-currency.component.html',
  styleUrls: ['./select-currency.component.scss'],
})
export class SelectCurrencyComponent implements OnInit, OnChanges, OnDestroy {
  @Input() label: string = '';
  @Input() value!: string | null;
  @Input() width: string = '175px';
  @Input() nameEP: string = 'company-currency-accounts';
  @Input() returnFirstValue: boolean = false;
  @Input() required: boolean = true;
  @Input() emptyOption: boolean = true;
  @Input() isSupported: boolean | null = null;
  @Input() isWithdrawable: boolean | null = null;
  @Output() valueChanged = new EventEmitter<any>();

  loading: boolean = true;
  currencies: any[] = [];
  currency: any;
  empty = {
    companyCurrencyAccountId: null,
    currencyCode: null,
    currencyIso: null,
  };

  private subscription: Subscription | null = null;

  constructor(private currencyAccountService: CurrencyAccountService) {}

  /**
   * component start
   * @author Martin Batun Tec.
   */
  ngOnInit(): void {
    this.subscription = this.currencyAccountService
      .getCurrencyAccounts(this.nameEP, this.isSupported, this.isWithdrawable)
      .subscribe(
        (data) => {
          this.currencies = data.records;
          this.loading = false;
          if ((this.returnFirstValue || this.value) && this.currencies.length) {
            this.currency = this.currencies.find(
              (e) => e.currencyIso == this.value,
            );
            this.valueChanged.next(
              this.currency ? this.currency : this.currencies[0],
            );
          }
        },
        (error) => {
          this.loading = false;
        },
      );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  /**
   * returns the array of step validations
   * @param changes changes inputs
   * @author Martin Batun Tec.
   */
  ngOnChanges(changes: SimpleChanges): void {
    this.loading = true;
    if (changes['value']) {
      setTimeout(
        () => {
          this.currency = this.currencies.find(
            (e) => e.currencyIso == changes['value'].currentValue,
          );
          this.currency = this.currency || this.empty;
          this.loading = false;
        },
        this.currencies.length ? 0 : 3000,
      );
    }
  }
}
